/** @jsx jsx */
import { jsx } from '@emotion/core';

import Widget from 'components/pages/Content/Widget';
import { StyledMobileContainer } from './styles';
import { WidgetsType } from '../../types';

export const WidgetDoubleFreeMobile = ({
  widgets,
}: {
  widgets: [WidgetsType, WidgetsType];
}): JSX.Element => {
  return (
    <StyledMobileContainer>
      {widgets.map((widget) => {
        return <Widget widget={widget} isDisplayOnWidgetDouble />;
      })}
    </StyledMobileContainer>
  );
};
